export enum AccountType {
    'Regular',
     'Partner'
}
